@if (labelsLoading()) {
  <div class="position-relative py-5">
    <mbs-loader [size]="'small'" />
  </div>
} @else {
  <div class="row">
    <div class="col-auto">
      <mbs-checkbox
        class="fw-semibold"
        label="Select all"
        name="permissionsSelectAll"
        [checked]="allPermissionsChecked()"
        [class.ml-3]="showTiles"
        [id]="idPrefix + 'permissionsSelectAll'"
        [indeterminate]="indeterminatePermissions()"
        (change)="handleSelectAll($event)"></mbs-checkbox>
    </div>
  </div>

  @for (block of blocks; track block.key) {
    @if (checkboxData()[block.key]?.length) {
      @if (showTiles) {
        <mbs-tile
          [attr.data-e2e]="block.e2e"
          [borderPadding]="'none'"
          [class]="'mt-3'"
          [data]="null"
          [disabled]="false"
          [headerTemplate]="blockTile"
          [hoverAble]="false"
          [selectable]="false"
          [selected]="false"
          [showBody]="false">
          <ng-template #blockTile>
            <div class="col px-0">
              <ng-container *ngTemplateOutlet="blockContent; context: { block: block, bordered: true }"></ng-container>
            </div>
          </ng-template>
        </mbs-tile>
      } @else {
        <div [attr.data-e2e]="block.e2e">
          <ng-container *ngTemplateOutlet="blockContent; context: { block: block, bordered: false }"></ng-container>
        </div>
      }
    }
  }
}

<ng-template
  #blockContent
  let-block="block"
  let-bordered="bordered">
  <div
    class="row mx-0"
    [class.border-bottom]="bordered">
    <div
      class="col-auto pt-2 pb-2 pl-0 fw-semibold d-flex align-items-center"
      [class.ml-3]="showTiles">
      <mbs-checkbox
        [checked]="blockChecked(block.key)"
        [descriptionOutside]="false"
        [disabledSelf]="blockDisabled(block.key)"
        [id]="idPrefix + block.key + 'SelectAll'"
        [indeterminate]="blockIndeterminate(block.key)"
        [label]="blockLabel"
        [name]="block.key + 'SelectAll'"
        (change)="handleSelectAll($event, block.key)">
        <ng-template
          checkboxDescription
          [hide]="block.key !== PermissionBlocksEnum.Mcp">
          <span class="text-sm fw-normal">{{ permissionDescriptions[PermissionsEnum.McpReadAccess] }}</span>
        </ng-template>
      </mbs-checkbox>
      <ng-template #blockLabel>
        {{ block.label }}
        @if (block.badge) {
          <span class="badge bg-danger text-white text-uppercase ml-2">{{ block.badge }}</span>
        }
      </ng-template>
    </div>
  </div>
  <div class="row mx-0">
    <div
      class="col-auto py-2 px-1"
      [class.ml-3]="showTiles">
      <mbs-tree
        class="px-4"
        classesForRoot="sidepanel-administrators-permissions-tree"
        mode="checkbox"
        [data]="checkboxData()[block.key]"
        [disableChildren]="true"
        [dontSelectChildren]="true"
        [expandAll]="true"
        [hideTreeIcon]="true"
        [idPrefix]="idPrefix"
        [itemClasses]="'permissions-item'"
        (mbsChange)="treeChangeHandler($event)">
        <ng-template
          let-item
          mbsTreeAppend>
          @if (permissionDescriptions[item.id]) {
            <span
              class="mbs-tree-item_append_span ml-4 text-sm"
              [ngClass]="item.parent && !item.parent.checked ? 'text-gray-500' : ''">
              {{ permissionDescriptions[item.id] }}
            </span>
          }
        </ng-template>
      </mbs-tree>
    </div>
  </div>
  @if (block.key === PermissionBlocksEnum.Mcp && mcpGlobalNote) {
    <div
      class="row mx-0 border-top"
      [class.border-bottom]="bordered">
      <div
        class="col py-2 pl-0"
        [class.ml-3]="showTiles">
        {{ mcpGlobalNote }}
        @if (mcpNoteSettingsLink) {
          <a [routerLink]="RoutingPath.ApSettings">{{ 'shared:administrators.mcpPermissions.settingsLink' | i18next }}</a>
        }
      </div>
    </div>
  }
</ng-template>
